import { render, staticRenderFns } from "./AccettazioneAbruzzoEdit.vue?vue&type=template&id=b9c663c4"
import script from "./AccettazioneAbruzzoEdit.vue?vue&type=script&lang=js"
export * from "./AccettazioneAbruzzoEdit.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneAbruzzoEdit.vue?vue&type=style&index=0&id=b9c663c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports